export const getPreviewHash = () => {
  const match = window.location.hash.match(/previewJwt=[^&]*/);
  return match ? `#${match[0]}` : '';
};
export const getIsPreview = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const isPreview = Boolean(searchParams.get('isPortalPreview'));
  if (isPreview) {
    const previewJwt = window.location.hash.split('previewJwt=')[1];
    const portalId = searchParams.get('portalId');
    return {
      isPreview: true,
      previewJwt: previewJwt !== null && previewJwt !== void 0 ? previewJwt : '',
      portalId: portalId !== null && portalId !== void 0 ? portalId : ''
    };
  }
  return {
    isPreview: false,
    previewJwt: null,
    portalId: null
  };
};